import React, { useState } from 'react';
import { MdArrowBack, MdCheckCircle, MdSwapHoriz } from 'react-icons/md';

const ACCOUNTS = [
  { id: 'chequing', name: 'Chequing Account', num: '...4521', balance: '$4,231.50' },
  { id: 'savings',  name: 'Savings Account',  num: '...8802', balance: '$12,840.00' },
  { id: 'tfsa',     name: 'TFSA',             num: '...3317', balance: '$8,500.00' },
];

const QUICK_PICKS = ['50', '100', '250', '500'];

const AccountTransferScreen = ({ onNavigate, onBack }) => {
  const [step, setStep]     = useState('form');
  const [from, setFrom]     = useState('chequing');
  const [to, setTo]         = useState('savings');
  const [amount, setAmount] = useState('');
  const [memo, setMemo]     = useState('');
  const [errors, setErrors] = useState({});
  const [refNum]            = useState(() => 'TRF' + Math.floor(Math.random() * 9000000 + 1000000));

  const fromAcct = ACCOUNTS.find(a => a.id === from);
  const toAcct   = ACCOUNTS.find(a => a.id === to);
  const toOptions = ACCOUNTS.filter(a => a.id !== from);

  const validate = () => {
    const e = {};
    if (from === to) e.to = 'From and To accounts must differ';
    const amt = parseFloat(amount);
    if (!amount || isNaN(amt) || amt <= 0) e.amount = 'Enter a valid amount';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const fmt = v => `$${parseFloat(v || 0).toFixed(2)}`;

  if (step === 'success') return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <h1 className="bh-flow-title">Transfer Funds</h1>
        </div>
      </header>
      <div className="emt-success-body">
        <div className="emt-success-circle"><MdCheckCircle size={52} color="var(--td-green)" /></div>
        <div className="emt-success-title">Transfer Complete!</div>
        <div className="emt-success-amount">{fmt(amount)}</div>
        <div className="emt-success-sub">{fromAcct?.name} → {toAcct?.name}</div>
        <div className="acct-transfer-ref">Ref: {refNum}</div>
        <button className="emt-primary-btn" style={{ marginTop: 32 }} onClick={() => onNavigate('home')}>Back to Services</button>
        <button className="emt-ghost-btn" onClick={() => { setStep('form'); setAmount(''); setMemo(''); setErrors({}); }}>New Transfer</button>
      </div>
    </div>
  );

  if (step === 'review') return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={() => setStep('form')} aria-label="Back">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Review Transfer</h1>
        </div>
      </header>
      <div className="scroll-content gray-bg">
        <div className="emt-review-amount">{fmt(amount)}</div>
        <div className="emt-section">
          <div className="emt-review-row">
            <span className="emt-review-label">From</span>
            <span className="emt-review-value">{fromAcct?.name}<br /><span style={{ fontSize: 11, color: 'var(--text-light)' }}>{fromAcct?.num} · {fromAcct?.balance}</span></span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">To</span>
            <span className="emt-review-value">{toAcct?.name}<br /><span style={{ fontSize: 11, color: 'var(--text-light)' }}>{toAcct?.num} · {toAcct?.balance}</span></span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Amount</span>
            <span className="emt-review-value">{fmt(amount)} CAD</span>
          </div>
          {memo && (
            <div className="emt-review-row">
              <span className="emt-review-label">Memo</span>
              <span className="emt-review-value" style={{ fontStyle: 'italic' }}>"{memo}"</span>
            </div>
          )}
          <div className="emt-review-row">
            <span className="emt-review-label">Timing</span>
            <span className="emt-review-value">Immediate · Same day</span>
          </div>
        </div>
        <div className="emt-notice">Transfers between your TD accounts are processed immediately and are generally available right away.</div>
        <button className="emt-primary-btn" onClick={() => setStep('success')}>
          <MdSwapHoriz size={16} style={{ marginRight: 6 }} /> Confirm Transfer
        </button>
        <button className="emt-ghost-btn" onClick={() => setStep('form')}>Edit</button>
      </div>
    </div>
  );

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Transfer Funds</h1>
        </div>
      </header>
      <div className="scroll-content gray-bg">

        <div className="emt-section">
          <div className="emt-section-title">From Account</div>
          {ACCOUNTS.map(a => (
            <div key={a.id} className={`emt-account-row${from === a.id ? ' selected' : ''}`} onClick={() => { setFrom(a.id); if (to === a.id) setTo(ACCOUNTS.find(x => x.id !== a.id)?.id); }}>
              <div className="emt-account-info">
                <div className="emt-account-name">{a.name}</div>
                <div className="emt-account-num">{a.num}</div>
              </div>
              <div className="emt-account-right">
                <div className="emt-account-balance">{a.balance}</div>
                <div className={`emt-radio${from === a.id ? ' on' : ''}`} />
              </div>
            </div>
          ))}
        </div>

        <div className="emt-section">
          <div className="emt-section-title">To Account</div>
          {toOptions.map(a => (
            <div key={a.id} className={`emt-account-row${to === a.id ? ' selected' : ''}`} onClick={() => { setTo(a.id); setErrors(p => ({ ...p, to: '' })); }}>
              <div className="emt-account-info">
                <div className="emt-account-name">{a.name}</div>
                <div className="emt-account-num">{a.num}</div>
              </div>
              <div className="emt-account-right">
                <div className="emt-account-balance">{a.balance}</div>
                <div className={`emt-radio${to === a.id ? ' on' : ''}`} />
              </div>
            </div>
          ))}
          {errors.to && <div className="emt-error" style={{ padding: '6px 16px' }}>{errors.to}</div>}
        </div>

        <div className="emt-section">
          <div className="emt-section-title">Amount</div>
          <div className={`emt-amount-wrapper${errors.amount ? ' error' : ''}`}>
            <span className="emt-currency-symbol">$</span>
            <input className="emt-amount-input" type="number" min="0" step="0.01" placeholder="0.00" value={amount} onChange={e => { setAmount(e.target.value); setErrors(p => ({ ...p, amount: '' })); }} />
            <span className="emt-currency-code">CAD</span>
          </div>
          {errors.amount && <div className="emt-error" style={{ marginTop: 6 }}>{errors.amount}</div>}
          <div className="emt-quick-amounts">
            {QUICK_PICKS.map(v => (
              <button key={v} className={`emt-quick-btn${amount === v ? ' active' : ''}`} onClick={() => { setAmount(v); setErrors(p => ({ ...p, amount: '' })); }}>${v}</button>
            ))}
          </div>
        </div>

        <div className="emt-section">
          <div className="emt-section-title">Memo <span style={{ fontWeight: 400, color: 'var(--text-light)', fontSize: 11 }}>(optional)</span></div>
          <textarea className="emt-textarea" placeholder="What's this transfer for?" maxLength={80} rows={2} value={memo} onChange={e => setMemo(e.target.value)} />
        </div>

        <button className="emt-primary-btn" onClick={() => { if (validate()) setStep('review'); }}>Continue</button>
      </div>
    </div>
  );
};

export default AccountTransferScreen;
